import React from "react";

const Button = ({
  variant = "secondary",
  size,
  icon: Icon,
  iconOnly = false,
  loading = false,
  className = "",
  children,
  type = "button",
  disabled,
  ...rest
}) => {
  const classes = [
    "cc-btn",
    `cc-btn--${variant}`,
    size === "sm" && "cc-btn--sm",
    iconOnly && "cc-btn--icon",
    loading && "is-loading",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <button type={type} className={classes} disabled={disabled || loading} {...rest}>
      {loading ? (
        <span className="cc-spinner" aria-hidden="true" />
      ) : (
        Icon && <Icon size={size === "sm" ? 15 : 17} strokeWidth={2} aria-hidden="true" />
      )}
      {!iconOnly && children}
    </button>
  );
};

export default Button;
